/**
 * The pilot's display callsign — what the PILOT rail page's title (`PILOT — <callsign>`) shows.
 *
 * A blank callsign is the *normal* case, not an edge: the picker's "＋ New pilot" tile mints
 * `callsign: ""`. `UNNAMED` matches the placeholder the rest of the shell uses for an un-filled
 * name (`GmRoster` rows, `NewEncounterForm`'s "UNNAMED ENCOUNTER").
 *
 * The guard **trims** rather than testing for `""`: `set_pilot_text` stores this freeform field
 * verbatim (no normalization in the reducer), so `"   "` is genuinely reachable by typing spaces
 * into the editor, and it renders exactly as blank as `""` does.
 */
export function pilotCallsignLabel(callsign: string | undefined): string {
  return (callsign?.trim() || "UNNAMED").toUpperCase();
}
